"use strict";

exports.__esModule = true;
exports.ChartTooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _d3Selection = require("d3-selection");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _class, _ChartTooltip;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ChartTooltipSVG = _styledComponents["default"].svg.withConfig({
  displayName: "ChartTooltip__ChartTooltipSVG",
  componentId: "sc-lbjryx-0"
})([".tooltipTextArrow{z-index:5;width:7px;height:7px;position:relative;}.tooltipTextBody{z-index:5;height:20px;}"]);
var defaultProps = {
  yPosition: 0,
  handleWidth: 1,
  theme: undefined
};

/**
 * ChartTooltip component to show a text label and a handle on a chart.
 * This does not support a custom react child component
 */
var ChartTooltip = exports.ChartTooltip = (0, _styledComponents.withTheme)(_class = (_ChartTooltip = /*#__PURE__*/function (_Component) {
  function ChartTooltip() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.registerContainer = function (container) {
      _this.container = container;
      if (container != null) {
        _this.renderTooltipHandle(container);
      }
    };
    _this.renderTooltipHandle = function (container) {
      var _this$props = _this.props,
        xPosition = _this$props.xPosition,
        yPosition = _this$props.yPosition,
        handleHeight = _this$props.handleHeight,
        handleWidth = _this$props.handleWidth,
        getLabel = _this$props.getLabel,
        theme = _this$props.theme;
      if (getLabel(xPosition) === null) {
        return;
      }
      var data = [{
        x: xPosition,
        data: getLabel(xPosition)
      }];
      var arrowX = 12;
      var arrowTransformY = 3;
      var bodyX = 10;
      var textX = 13;
      var tooltipArrowY = 5;
      var tooltipBodyY = 0;
      var tooltipTextY = 15;
      var tooltipTextCharacterFactor = 7;
      var tooltipTextPadding = 8;
      var tooltipTextWidth = function tooltipTextWidth(d) {
        return ("" + d.data).replace(".", "").length * tooltipTextCharacterFactor;
      };
      var tooltipBackgroundColor = theme.TooltipTextBackground;
      var selection = (0, _d3Selection.select)(container);
      var tooltipHandle = selection.selectAll(".tooltipHandle").data([xPosition]).attr("x", function (d) {
        return d;
      });
      tooltipHandle.enter().append("rect").attr("class", "tooltipHandle").attr("fill", theme.ToolTipHandleColor).attr("x", function (d) {
        return d;
      }).attr("y", yPosition).attr("width", handleWidth).attr("height", handleHeight);
      var tooltipTextArrow = selection.selectAll(".tooltipTextArrow").data(data).attr("x", function (d) {
        return d.x + arrowX;
      }).attr("transform-origin", function (d) {
        return d.x + arrowX + "px " + arrowTransformY + "px";
      });
      tooltipTextArrow.enter().append("rect").attr("class", "tooltipTextArrow").attr("fill", tooltipBackgroundColor).attr("stroke", tooltipBackgroundColor).attr("transform", "rotate(45)").attr("transform-origin", function (d) {
        return d.x + arrowX + "px " + arrowTransformY + "px";
      }).attr("x", function (d) {
        return d.x + arrowX;
      }).attr("y", tooltipArrowY);
      var tooltipTextBody = selection.selectAll(".tooltipTextBody").data(data).attr("x", function (d) {
        return d.x + bodyX;
      }).style("width", function (d) {
        return "" + (tooltipTextWidth(d) + tooltipTextPadding);
      });
      tooltipTextBody.enter().append("rect").attr("class", "tooltipTextBody").attr("rx", theme.uiModern ? 4 : null).attr("fill", tooltipBackgroundColor).attr("stroke", tooltipBackgroundColor).style("width", function (d) {
        return "" + (tooltipTextWidth(d) + tooltipTextPadding);
      }).attr("x", function (d) {
        return d.x + bodyX;
      }).attr("y", tooltipBodyY);
      var tooltipText = selection.selectAll("text").data(data).attr("x", function (d) {
        return d.x + textX;
      }).attr("textLength", function (d) {
        return tooltipTextWidth(d);
      }).text(function (d) {
        return d.data;
      });
      tooltipText.enter().append("text").style("z-index", "10").style("font-size", theme.fontSizeXXS).style("font-family", theme.uiModern ? theme.ChartFontFamilyMono : null).attr("fill", theme.uiModern ? theme.TooltipContentColor : null).attr("textLength", function (d) {
        return tooltipTextWidth(d);
      }).style("height", "20").attr("x", function (d) {
        return d.x + textX;
      }).attr("y", tooltipTextY).text(function (d) {
        return d.data;
      });
    };
    return _this;
  }
  _inheritsLoose(ChartTooltip, _Component);
  var _proto = ChartTooltip.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.container != null) {
      this.renderTooltipHandle(this.container);
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height;
    return /*#__PURE__*/_react["default"].createElement(ChartTooltipSVG, {
      "data-testid": "ChartTooltip",
      height: height,
      width: width,
      ref: this.registerContainer
    });
  };
  return ChartTooltip;
}(_react.Component), _ChartTooltip.defaultProps = defaultProps, _ChartTooltip)) || _class;